import React, { useEffect,useRef } from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import dayjs from 'dayjs';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { InputAdornment } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PasswordIcon from '@mui/icons-material/Password';
// import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import TagManager from "react-gtm-module";
import { bookingRequestSuccessful } from '../../gtm';
import ReactGA from "react-ga4";
import { setRecordPaymentResponse } from "../../redux/actions/recordPaymentActions";


const AFProcessSaleV5 = function (
  merchantID,
  orderValue,
  orderRef,
  payoutCodes,
  offlineCode,
  voucherCodes,
  productList,
  sourceCurrency
) {
  let iframe = document.createElement("iframe");
  let secure = document.location.toString().indexOf("https") === 0;
  let affc = getCookie("Affc");

  let RN = Math.random().toString();
  let RNS = RN.substring(2, 11);

  voucherCodes = voucherCodes || "";
  productList = productList || "";
  sourceCurrency = sourceCurrency || "";

  iframe.border = "0";
  iframe.width = "1";
  iframe.height = "1";

  if (secure) {
    // console.log("check scripts running")
    iframe.src = `https://scripts.affiliatefuture.com/AFSaleV5.aspx?orderID=${orderRef}&orderValue=${orderValue}&merchant=${merchantID}&payoutCodes=${payoutCodes}&offlineCode=${offlineCode}&voucher=${voucherCodes}&products=${productList}&curr=${sourceCurrency}&affc=${affc}&r=${RNS}`;
  } else {
    iframe.src = `http://scripts.affiliatefuture.com/AFSaleV5.aspx?orderID=${orderRef}&orderValue=${orderValue}&merchant=${merchantID}&payoutCodes=${payoutCodes}&offlineCode=${offlineCode}&voucher=${voucherCodes}&products=${productList}&curr=${sourceCurrency}&affc=${affc}&r=${RNS}`;
  }

  document.body.appendChild(iframe);
};

const getCookie = name => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  greenAlert: {
    backgroundColor: '#4CAF50', // Green color
    color: 'white', // Text color
    fontSize: '16px',
    fontFamily: 'Nexa,sans-serif',
  },
  title: {
    color: '#444',
    fontSize: '22px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: '700',
    backgroundColor: '#fff',
    textAlign: 'center',
    lineHeight: '1.1',
    marginBottom: '20px'
  },
  title2: {
    textAlign: 'center',
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '20px',
    lineHeight: '1.1',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: '500',
    color: '#265886',
    marginTop: '20px',
    backgroundColor: '#F7FBFF'
  },
  subtitle1: {
    textAlign: 'center',
    fontSize: '1em',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    fontWeight: '700',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    textTransform: 'none',
  },
  underline: {
    position: 'relative',
    display: 'inline-block',
  },
  underlineBefore: {
    position: 'absolute',
    content: '""',
    left: 85,
    right: 0,
    bottom: -8,
    height: '5px',
    width: '32%',
    backgroundColor: '#138911',
    borderRadius: '5px',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  button2: {
    backgroundColor: '#265886',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  luggageSection: {
    marginTop: '20px',
  },
  luggageTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  termsInfo: {
    color: '#265886',
    fontSize: '22px',
    marginBottom: '-5px'
  },
  luggageButton: {
    display: 'flex',
    alignItems: 'center',
  },
  luggageIcon: {
    marginRight: '5px',
  },
  tickIcon: {
    fontWeight: 'bold'
  },
  terms: {
    fontSize: '16px',
    fontFamily: "Nexa,sans-serif",
    color: '#265886'
  },
  price1: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '30px',
    color: '#265886',
  },
  price2: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '17px',
    color: '#265886',
    marginLeft: '150px',
    marginTop: '10px'
  },
  ccImg: {
    background: `url('/assets/visa-mastercard-logos.png') no-repeat center`,
    backgroundSize: '100%',
    height: '56px',
    width: '150px',
    margin: '0 auto 6px auto',
  },
});


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },

}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#F7FBFF",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));



const BookingSuccess = ({ classes, theme, currency, showSpinner }) => {
  
  const { book } = useParams();
  const paymentRecordedRef = useRef(false); // Flag to ensure single API call

  const location = useLocation();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const dispatch = useDispatch();
  const quoteResponse = useSelector((state) => state.quoteResponse);
  const { totalCost } = useSelector((state) => state.booking);
  const bookingDetails = useSelector((state) => state.customer);
  const createBookingResponse = useSelector(state => state.createBooking);
  // const transferTypeCodeToMatch = createBookingResponse.basket.transfers[0].transferType.code;
  const intentResponse = useSelector(state => state.createIntent);
  // const matchedOption = createBookingResponse.basket.options.find(option => option.transferTypeCode === transferTypeCodeToMatch);

  // var book = createBookingResponse.basket.canBook;
  const travelDetails = useSelector(state => state.travelDetails);
  const createBookingDetails = useSelector((state) => state.createBooking);

  const destinationType = {
    AIRPORT: 'AIR',
    RESORT: 'RES',
    TRAIN: 'TRBU',
    FERRY: 'FERR',
    BUS: 'BUS',
    GOLF: 'GOLF',
    LOCATION: 'LOCATION',
    CITY: 'CITY'
  };

  // Function to get outbound time label based on the origin and destination types
  const getOutTimeLabel = (fromType, toType) => {
    if (fromType === destinationType.GOLF && toType === destinationType.AIRPORT) return 'Flight Departure Time';
    if (fromType === destinationType.GOLF && toType === destinationType.BUS) return 'Bus Departure Time';
    if (fromType === destinationType.GOLF && toType === destinationType.FERRY) return 'Cruise Embarkation Time';
    if (fromType === destinationType.GOLF && toType === destinationType.GOLF) return 'Tee Time';
    if (fromType === destinationType.GOLF && toType === destinationType.TRAIN) return 'Train Departure Time';
    if (fromType === destinationType.GOLF && toType === destinationType.RESORT) return 'Pick Up Time';

    if (fromType === destinationType.RESORT && toType === destinationType.AIRPORT) return 'Flight Departure Time';
    if (fromType === destinationType.RESORT && toType === destinationType.BUS) return 'Bus Departure Time';
    if (fromType === destinationType.RESORT && toType === destinationType.FERRY) return 'Cruise Embarkation Time';
    if (fromType === destinationType.RESORT && toType === destinationType.GOLF) return 'Tee Time';
    if (fromType === destinationType.RESORT && toType === destinationType.TRAIN) return 'Train Departure Time';
    if (fromType === destinationType.RESORT && toType === destinationType.RESORT) return 'Pick Up Time';

    if (fromType === destinationType.AIRPORT) return 'Flight Arrival Time';
    if (fromType === destinationType.BUS) return 'Bus Arrival Time';
    if (fromType === destinationType.FERRY) return 'Cruise Disembarkation Time';
    if (fromType === destinationType.TRAIN) return 'Train Arrival Time';

    return 'Pick Up Time'; // Default case
  };

  // Function to get return time label based on the origin and destination types
  const getReturnTimeLabel = (fromType, toType) => {
    if (fromType === destinationType.GOLF && toType === destinationType.AIRPORT) return 'Flight Arrival Time';
    if (fromType === destinationType.GOLF && toType === destinationType.BUS) return 'Bus Arrival Time';
    if (fromType === destinationType.GOLF && toType === destinationType.FERRY) return 'Cruise Disembarkation Time';
    if (fromType === destinationType.GOLF && toType === destinationType.GOLF) return 'Tee Time';
    if (fromType === destinationType.GOLF && toType === destinationType.TRAIN) return 'Train Arrival Time';
    if (fromType === destinationType.GOLF && toType === destinationType.RESORT) return 'Pick Up Time';

    if (fromType === destinationType.RESORT && toType === destinationType.AIRPORT) return 'Flight Arrival Time';
    if (fromType === destinationType.RESORT && toType === destinationType.BUS) return 'Bus Arrival Time';
    if (fromType === destinationType.RESORT && toType === destinationType.FERRY) return 'Cruise Disembarkation Time';
    if (fromType === destinationType.RESORT && toType === destinationType.GOLF) return 'Pick Up Time';
    if (fromType === destinationType.RESORT && toType === destinationType.TRAIN) return 'Train Arrival Time';

    if (fromType === destinationType.AIRPORT) return 'Flight Departure Time';
    if (fromType === destinationType.BUS) return 'Bus Departure Time';
    if (fromType === destinationType.FERRY) return 'Cruise Embarkation Time';
    if (fromType === destinationType.TRAIN) return 'Train Departure Time';

    return 'Pick Up Time'; // Default case
  };
  const transportTypeMapping = {
    AIR: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Flight Number",
      RES: "Flight Number",
      TRBU: "Train Number",
    },
    BUS: {
      AIR: "Bus Number",
      BUS: "Bus Number",
      FERR: "Bus Number",
      GOLF: "Bus Number",
      RES: "Bus Number",
      TRBU: "Bus Number",
    },
    FERR: {
      AIR: "Cruise Number",
      BUS: "Cruise Number",
      FERR: "Cruise Number",
      GOLF: "Cruise Number",
      RES: "Cruise Number",
      TRBU: "Cruise Number",
    },
    GOLF: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    RES: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    TRBU: {
      AIR: "Train Number",
      BUS: "Train Number",
      FERR: "Train Number",
      GOLF: "Train Number",
      RES: "Train Number",
      TRBU: "Train Number",
    },
  };


  // Function to get transport type based on destination types
  const getTransportType = (fromType, toType) => {
    if (transportTypeMapping[fromType] && transportTypeMapping[fromType][toType]) {
      return transportTypeMapping[fromType][toType];
    }
    return "Transport Number"; // Fallback if no mapping is found
  };
  //  Get transport types based on travel details
  const fromType = travelDetails.pickupValue.type; // e.g., 'AIR'
  const toType = travelDetails.dropoffValue.type;  // e.g., 'RES'

  const transportTypeOutbound = getTransportType(fromType, toType);
  const transportTypeReturn = getTransportType(toType, fromType);
  // Function to get transport time label based on the origin and destination types

  const getTransportTimeLabel = (fromType, toType, isOutbound) => {
    return isOutbound ? getOutTimeLabel(fromType, toType) : getReturnTimeLabel(fromType, toType);
  };

  // Sample usage
  const outboundTimeLabel = getTransportTimeLabel(travelDetails.pickupValue.type, travelDetails.dropoffValue.type, true); // Outbound
  const returnTimeLabel = getTransportTimeLabel(travelDetails.pickupValue.type, travelDetails.dropoffValue.type, false); // Return



  // console.log("check bookings", book)
  // const privelegedDetails = useSelector((state) => state.priveleged);




  // NO RETURN PAGE 

  // const navigate = useNavigate();

  // useEffect(() => {


  //   // Use navigate to replace the current route with the /success route
  //   navigate('/success', { replace: true });

  //   // Define a clean-up function
  //   const cleanUp = () => {
  //     // Use navigate to navigate back to the previous page if needed
  //     navigate('/success');
  //   };



  //   // Clean up the event listener when the component unmounts
  //   return cleanUp;


  // }, [navigate ]);

  if (book) {
    const bookingRequestSuccessfulDetails = {
      currency: quoteResponse.basket.currency[0],
      value: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
      items: [{
        item_name: createBookingResponse.basket.transfers[0].fromDestination.name + " to " + createBookingResponse.basket.transfers[0].toDestination.name, // Name of the item
        price: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
        item_category: createBookingResponse.basket.transfers[0].transferType.description,
        item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
        quantity: 1 // Quantity of the item
      }]
    }
    bookingRequestSuccessful(bookingRequestSuccessfulDetails)

    if (createBookingResponse.basket.transfers && createBookingResponse.basket.totalCost > 0) {
      /* Tag Manager */
      const tagManagerArgs = {
        gtmId: "GTM-PC8TZH",
        dataLayer: {
          event: "transaction",
          email: createBookingResponse.basket.transfers[0].email,
          firstname: createBookingResponse.basket.transfers[0].forename, //FirstName field value from Transfer One Lead Passenger details
          surname: createBookingResponse.basket.transfers[0].surname, //Surname field value from Transfer One Lead Passenger details
          journeyDate: createBookingResponse.basket.transfers[0].date, // journey date from Transfer One
          numberOfChildren: createBookingResponse.basket.transfers[0].children.length, // Children field  value from Transfer One booking details
          numberOfAdults: createBookingResponse.basket.transfers[0].adults, // Adults field value from Transfer One booking details
          transactionId: createBookingResponse.basket.bookingId,
          transactionTotal: (createBookingResponse.basket.totalCost / 100).toFixed(2),
          currencyCode: createBookingResponse.basket.currency[0],
          transactionProducts: []
        }
      };

      // tagManagerArgs.dataLayer.transactionProducts[0] = {
      //   sku: createBookingResponse.basket.transfers[0].id, //If you assign an ID to Type of Transfer, you can put it there
      //   name:
      //   createBookingResponse.basket.fromDestination.name +
      //     " to " +
      //     createBookingResponse.basket.transfers[0].toDestination.name,
      //   category: createBookingResponse.basket.transfers[0].transferType.code, //Type of Transfer
      //   price: (createBookingResponse.basket.totalCost.totalCost / 100).toFixed(
      //     2
      //   ),
      //   quantity: 1
      // };

      if (createBookingResponse.basket.transfers[1]) {
        tagManagerArgs.dataLayer.transactionProducts[1] = {
          sku: createBookingResponse.basket.transfers[1].id, //If you assign an ID to Type of Transfer, you can put it there
          name:
            createBookingResponse.basket.transfers[1].fromDestination.name +
            " to " +
            createBookingResponse.basket.transfers[1].toDestination.name,
          category: createBookingResponse.basket.transfers[1].transferType.code, //Type of Transfer
          price: (createBookingResponse.basket.totalCost / 100).toFixed(
            2
          ),
          quantity: 1
        };
      }

      TagManager.initialize(tagManagerArgs);
      /* Affiliate Futures */



      if (createBookingResponse.basket.transfers && createBookingResponse.basket.totalCost > 0) {

        AFProcessSaleV5(
          "6953",
          (createBookingResponse.basket.totalCost / 100).toFixed(2),
          createBookingResponse.basket.bookingId,
          "",
          "",
          "",
          "",
          createBookingResponse.basket.currency[0]
        );
      }
    }

  }

  // var book1 = null;
  // const combinations = useSelector((state) => state.mixedProduct.combinations);
  // const matchedOption1 = createBookingResponse.basket.options.find(option => option.transferTypeCode === transferTypeCodeToMatch);

  // console.log("booking check", book)

  // book1 = (createBookingResponse.basket.canBook);


  // if(createBookingResponse.basket.transfers[0].transferType.code !== createBookingResponse.basket.transfers[1].transferType.code){
  //   const match = combinations.find(combination =>
  //     combination.outbound.transferTypeCode === transferTypeCodeToMatch ||
  //     combination.inbound.transferTypeCode === transferTypeCodeToMatch
  //   );
  //   console.log("match chec", match)

  //   book1 = match ? (match.outbound.transferTypeCode === transferTypeCodeToMatch ? match.outbound.book : match.inbound.book) : false;

  // }
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    scrollToTop();

    // Extract query params from URL
    const params = new URLSearchParams(location.search);
    const txid = params.get("txid");

    // Check if path is /success/true and txid is present, and if payment has not been recorded
    if (location.pathname === "/success/true" && txid && !paymentRecordedRef.current && createBookingResponse) {
      paymentRecordedRef.current = true; // Set flag to true to prevent further calls

      const paymentDetails = {
        bookingId: intentResponse.bookingId,
        transactionId: txid,
        intentId: intentResponse.intentId,
        amount: intentResponse.amount,
        currencyCode: intentResponse.currencyCode,
      };
      const headers = {
        "Content-Type": "application/json"
      };

      fetch(`${apiBaseUrl}/basket/recordPayment`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(paymentDetails),
      })
        .then((response) => response.json())
        .then((data) => {
          dispatch(setRecordPaymentResponse(data));

          // Clear ecommerce data in GTM dataLayer
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });

          // Send Google Analytics purchase event
          ReactGA.event({
            category: "Ecommerce",
            action: "Purchase",
            ecommerce: {
              transaction_id: createBookingResponse.basket.bookingId,
              affiliation: "Online Store",
              value: totalCost,
              currency: createBookingResponse.basket.currency[0],
              tax: 0,
              shipping: 0,
              coupon: createBookingResponse.basket.promoCode,
              items: createBookingResponse.basket.transfers.map((transfer) => ({
                item_name: `${transfer.fromDestination.name} to ${transfer.toDestination.name}`,
                item_id: transfer.id,
                price: transfer.price,
                item_brand: transfer.brand,
                item_category: transfer.transferType.description,
                item_variant: transfer.variant,
                quantity: 1,
              })),
            },
          });
        })
        .catch((error) => console.error("Error recording payment:", error));
    }
  }, [location, dispatch, intentResponse, createBookingResponse, apiBaseUrl, totalCost]);

  return (
    <div>
      <Grid container spacing={2} sx={{
        flexGrow: 1,
        backgroundColor: '#FCFDFD',
      }} className={`${classes.root} ${classes.spacing}`}>
        {/* TITLE */}
        <Grid item xs={12} md={12}>
          <Typography variant="h2" sx={{
            textAlign: 'center',
            fontSize: '1.8rem',
            fontWeight: '700',
            color: '#333',
            fontFamily: 'Nexa,sans-serif',
            lineHeight: '1.1',
          }}>
            <span className={classes.underline}> {book === "true" ? "Booking Complete" : "Request Received"}<span className={classes.underlineBefore}></span></span>
          </Typography>
        </Grid>

        <Grid item xs={12} md={12} sx={{ marginTop: '20px' }}>
          <Alert severity="success" sx={{
            backgroundColor: '#4CAF50', // Green color
            color: 'white', // Text color
            fontSize: '16px',
            fontFamily: 'Nexa,sans-serif',
          }}>
            <AlertTitle>
              {book === "true"
                ? "Success!"
                : "Checking Availability"
              }
            </AlertTitle>
            {book === "true"
              ? `Your booking is confirmed and you are going to be sent an email booking confirmation which has important instructions for you to follow on the day of your transfer. Your booking reference is ${createBookingDetails.basket.bookingId}. Please make sure you check your junk folder for emails and add us to your safe senders list.`
              : `We are working on finding a transfer for you and will be in touch by text or email soon. Please respond to our SMS or email ASAP within 1 hour in order to confirm your transfers. Please check your junk folder for emails and add us to your safe sender's list. Your booking request reference is  ${createBookingDetails.basket.bookingId}.`
            }
          </Alert>
        </Grid>

        {/* Check if privileged account found */}
        {createBookingDetails.user.allowGuest === false && (
          <Grid item xs={12} md={3}></Grid>
        )}


        <Grid item xs={12} md={1}></Grid>
        {/* Check if privileged account found */}
        {createBookingDetails.user.allowGuest === true && (
          <Grid item xs={12} md={5} sx={{ marginTop: '32px' }}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography variant="h2" sx={{
                  textAlign: 'center',
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#333',
                  fontFamily: 'Nexa,sans-serif',
                  lineHeight: '1.1',
                }} className={`${classes.spacing}`}>
                  Create a New Account?
                </Typography>
                <Box component="form" noValidate sx={{ mt: 1 }}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="firstName"
                    id="firstName"
                    label="First Name"
                    autoFocus
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="family-name"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    type="email"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    label="Password"
                    name="password"
                    autoComplete="password"
                    type="password"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <PasswordIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        mt: 3, mb: 2, backgroundColor: 'rgb(17, 137, 17)',
                        color: 'rgb(255, 255, 255)',
                        borderRadius: '6px',
                        marginTop: '14px',
                        padding: '0px 50px',
                        fontFamily: '"Nexa","Arial",sans-serif!important',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '1.75',
                        letterSpacing: '0.02857em',
                        minWidth: '183px',
                        minHeight: '50px',
                        display: 'flex',
                      }}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      CREATE AN ACCOUNT
                    </Button>
                  </div>
                  <Grid container>
                    {/* Additional form components */}
                  </Grid>
                </Box>
              </Box>
            </Container>
          </Grid>
        )}

        {/* OUTBOUND Transfer */}
        <Grid item xs={12} md={5} sx={{ marginTop: '30px' }}>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={2} sx={{
                    color: '#444',
                    fontSize: '22px',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: '700',
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    lineHeight: '1.1',
                    marginBottom: '20px'
                  }}>
                    Outbound Transfer
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={2} sx={{
                    textAlign: 'center',
                    fontSize: '20px',
                    lineHeight: '1.1',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: '500',
                    color: '#265886',
                    marginTop: '20px',
                    backgroundColor: '#F7FBFF'
                  }}>
                    {travelDetails.pickupValue.label}&nbsp;
                    <ChevronRightIcon style={{ fontWeight: 'bolder', verticalAlign: 'middle', marginBottom: '4px' }} />
                    &nbsp;{travelDetails.dropoffValue.label}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    <strong> Departing Date  </strong>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                    {dayjs(travelDetails.outboundDate).format('D MMM, YYYY')}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    <strong> {outboundTimeLabel} </strong>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                    {travelDetails.outboundTime}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    <strong> {transportTypeOutbound} </strong>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                    {bookingDetails.booking.outboundFlightNumber}
                  </StyledTableCell>
                </StyledTableRow>
                {travelDetails.adultsCount > 0 && (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                      <strong> Adults </strong>
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                      {travelDetails.adultsCount}
                    </StyledTableCell>
                  </StyledTableRow>
                )}

                {travelDetails.childrenCount.length > 0 && (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                      <strong> Children </strong>
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                      {travelDetails.childrenCount.length}
                    </StyledTableCell>
                  </StyledTableRow>
                )}

                {travelDetails.infantsCount > 0 && (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                      <strong> Infants </strong>
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                      {travelDetails.infantsCount}
                    </StyledTableCell>
                  </StyledTableRow>
                )}

              </TableBody>
            </Table>
          </TableContainer>

          {/* RETURN TRANSFER  */}
          {
            createBookingDetails.basket.transfers.length > 1 && (
              <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell colSpan={2} sx={{
                        color: '#444',
                        fontSize: '22px',
                        fontFamily: 'Nexa,sans-serif',
                        fontWeight: '700',
                        backgroundColor: '#fff',
                        textAlign: 'center',
                        lineHeight: '1.1',
                        marginBottom: '20px'
                      }}>
                        Return Transfer
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell colSpan={2} sx={{
                        textAlign: 'center',
                        fontSize: '20px',
                        lineHeight: '1.1',
                        fontFamily: 'Nexa,sans-serif',
                        fontWeight: '500',
                        color: '#265886',
                        marginTop: '20px',
                        backgroundColor: '#F7FBFF'
                      }}>
                        {travelDetails.dropoffValue.label} &nbsp;
                        <ChevronRightIcon style={{ fontWeight: 'bolder', verticalAlign: 'middle', marginBottom: '4px' }} />
                        &nbsp;{travelDetails.pickupValue.label}
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                        <strong> Return Date  </strong>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                        {dayjs(travelDetails.returnDate).format('D MMM, YYYY')}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                        <strong> {returnTimeLabel} </strong>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                        {travelDetails.returnTime}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                        <strong> {transportTypeReturn}  </strong>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                        {bookingDetails.booking.returnFlightNumber}
                      </StyledTableCell>
                    </StyledTableRow>
                    {travelDetails.adultsCount > 0 && (
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                          <strong> Adults </strong>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                          {travelDetails.adultsCount}
                        </StyledTableCell>
                      </StyledTableRow>
                    )}

                    {travelDetails.childrenCount.length > 0 && (
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                          <strong> Children </strong>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                          {travelDetails.childrenCount.length}
                        </StyledTableCell>
                      </StyledTableRow>
                    )}

                    {travelDetails.infantsCount > 0 && (
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                          <strong> Infants </strong>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                          {travelDetails.infantsCount}
                        </StyledTableCell>
                      </StyledTableRow>
                    )}

                  </TableBody>
                </Table>
              </TableContainer>
            )}
        </Grid>




      </Grid>







    </div>
  );
};

export default withStyles(styles, { withTheme: true })(BookingSuccess);

